export function apiErrorMessageFromError(error, fallback = "Request failed.") {
  const responseData = error?.response?.data || {};
  const rawMessage =
    responseData?.data?.error_message ||
    responseData?.error_message ||
    responseData?.message ||
    fallback;

  if (typeof rawMessage !== "string") {
    return fallback;
  }

  const trimmedMessage = rawMessage.trim();
  return trimmedMessage || fallback;
}
